import { Column, Row } from '@xo-union/tk-component-grid';
import React, { type FunctionComponent } from 'react';
import { SponsoredResultsDisclaimer } from '../../../components/SponsoredResultsDisclaimer';
import FilterPillCategory from '../../FilterPills/containers/FilterPills/filterPillCategory';

const QuickFilterSortby: FunctionComponent<Props> = (props) => {
	return (
		<Row>
			<Column xs="12" lg="7" xl="8" xxl="9">
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<SponsoredResultsDisclaimer />
					<div style={{ marginLeft: 'auto' }}>
						<FilterPillCategory key="sort" filterCategory="Sort" />
					</div>
				</div>
			</Column>
			<Column lg="5" xl="4" xxl="3" />
		</Row>
	);
};
export default QuickFilterSortby;
